export default __webpack_public_path__ + "static/media/businessmeet.93603807.webp";